import 'regenerator-runtime/runtime';
import { call, cancel, put, takeEvery } from 'redux-saga/effects';
import {
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { JhpActions } from '../jhpActions';

export function* watchAntragsnummerRequested() {
  yield takeEvery(GlobalActions.ANTRAGSNUMMER_REQUESTED, safeSaga(antragsnummerSaga, App.JHP));
  yield takeEvery(JhpActions.VORSCHLAGDATEN_CHANGED, safeSaga(antragsnummerSaga, App.JHP));
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.JHP),
  );
}

export function* antragsnummerSaga(action: AnyAction) {
  if (action.payload?.appId === App.JHP || action.type === JhpActions.VORSCHLAGDATEN_CHANGED) {
    const globalPut = GlobalPut.getInstance();

    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().doRequestAntragsnummer(
        App.JHP,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
      ),
    );
  }
}

export function* successCallback(successAction: DoRequestResponse<string>) {
  try {
    if (successAction.doRequestAction.payload.appId === App.JHP) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(new JhpActions().antragsnummerGenerated(antragsnummerAsString));
      yield call([globalPut, globalPut.put], new GlobalActions().antragsnummerGenerated());
    }
  } catch (exception) {
    PS20Logger.error(
      App.JHP,
      exception as Error,
      'antragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}
